// extracted by mini-css-extract-plugin
export var container = "ad-section-module--container--LQHsb";
export var textSection = "ad-section-module--textSection--Guqk8";